module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Light-Alphabetic.8fcdcc74.woff";